import React, { useEffect, useRef, useState } from "react";
import { Box, Dialog, Typography } from "@mui/material";

export default function SignatureInput(props) {
  const { id, label, value, readOnly, onChange } = props;

  const containerRef = useRef(null);

  const [internalValue, setInternalValue] = useState(value);
  const [canvasWidth, setCanvasWidth] = useState(0);
  const [showBigImage, setShowBigImage] = useState(false);

  const handleOnChange = (newValue) => {
    setInternalValue(newValue);
    onChange(id, newValue);
  };

  useEffect(() => {
    if (internalValue) {
      setInternalValue(value);
    }
  }, [value]);

  useEffect(() => {
    if (!readOnly) {
      window.requestAnimFrame = (function (callback) {
        return (
          window.requestAnimationFrame ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame ||
          window.oRequestAnimationFrame ||
          window.msRequestAnimaitonFrame ||
          function (callback) {
            window.setTimeout(callback, 1000 / 60);
          }
        );
      })();

      var canvas = document.getElementById("sig-canvas");

      var drawing = false;
      var mousePos = {
        x: 0,
        y: 0,
      };
      var lastPos = mousePos;

      canvas.addEventListener(
        "mousedown",
        function (e) {
          drawing = true;
          lastPos = getMousePos(canvas, e);
        },
        false
      );

      canvas.addEventListener(
        "mouseup",
        function (e) {
          drawing = false;
        },
        false
      );

      canvas.addEventListener(
        "mousemove",
        function (e) {
          mousePos = getMousePos(canvas, e);
        },
        false
      );

      // Add touch event support for mobile
      canvas.addEventListener("touchstart", function (e) {}, false);

      canvas.addEventListener(
        "touchmove",
        function (e) {
          var touch = e.touches[0];
          var me = new MouseEvent("mousemove", {
            clientX: touch.clientX,
            clientY: touch.clientY,
          });
          canvas.dispatchEvent(me);
        },
        false
      );

      canvas.addEventListener(
        "touchstart",
        function (e) {
          mousePos = getTouchPos(canvas, e);
          var touch = e.touches[0];
          var me = new MouseEvent("mousedown", {
            clientX: touch.clientX,
            clientY: touch.clientY,
          });
          canvas.dispatchEvent(me);
        },
        false
      );

      canvas.addEventListener(
        "touchend",
        function (e) {
          var me = new MouseEvent("mouseup", {});
          canvas.dispatchEvent(me);
        },
        false
      );

      function getMousePos(canvasDom, mouseEvent) {
        var rect = canvasDom.getBoundingClientRect();
        return {
          x: mouseEvent.clientX - rect.left,
          y: mouseEvent.clientY - rect.top,
        };
      }

      function getTouchPos(canvasDom, touchEvent) {
        var rect = canvasDom.getBoundingClientRect();
        return {
          x: touchEvent.touches[0].clientX - rect.left,
          y: touchEvent.touches[0].clientY - rect.top,
        };
      }

      var ctx = canvas.getContext("2d");

      function renderCanvas() {
        if (drawing) {
          ctx.strokeStyle = "#222222";
          ctx.lineWidth = 4;

          ctx.moveTo(lastPos.x, lastPos.y);
          ctx.lineTo(mousePos.x, mousePos.y);
          ctx.stroke();
          lastPos = mousePos;
        }
      }

      // Prevent scrolling when touching the canvas
      document.body.addEventListener(
        "touchstart",
        function (e) {
          if (e.target == canvas) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        "touchend",
        function (e) {
          if (e.target == canvas) {
            e.preventDefault();
          }
        },
        false
      );
      document.body.addEventListener(
        "touchmove",
        function (e) {
          if (e.target == canvas) {
            e.preventDefault();
          }
        },
        false
      );

      (function drawLoop() {
        window.requestAnimFrame(drawLoop);
        renderCanvas();
      })();
    }
  }, []);

  useEffect(() => {
    if (containerRef.current) {
      setCanvasWidth(containerRef.current.clientWidth);
    }
  }, []);

  if (readOnly) {
    return (
      <div>
        {internalValue !== undefined && (
          <img
            src={internalValue}
            alt="Signature Image"
            style={{
              height: 150,
              objectFit: "contain",
              borderRadius: "15px",
              backgroundColor: "white",
            }}
            onClick={() => setShowBigImage(true)}
          />
        )}
        {showBigImage && (
          <Dialog
            open={showBigImage}
            onClose={() => setShowBigImage(false)}
            sx={{ borderRadius: "15px" }}
          >
            <img
              alt=""
              height={"100%"}
              width={"100%"}
              style={{ backgroundColor: "white" }}
              src={internalValue}
              onClick={() => setShowBigImage(false)}
            />
          </Dialog>
        )}
      </div>
    );
  }

  return (
    <div id={`no-drag-${id}`} onClick={(e) => e.stopPropagation()}>
      <h4 className="col-12">{label}</h4>
      <div
        ref={containerRef}
        className="col-12"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <canvas
          id="sig-canvas"
          //width="620"
          height="160"
          width={canvasWidth}
          style={{
            border: "2px dotted #CCCCCC",
            borderRadius: "15px",
            cursor: "crosshair",
            display: internalValue === undefined ? "inherit" : "none",
            backgroundColor: "white",
          }}
        >
          {"This browser does not support HTML5 Canvas"}
        </canvas>
        {internalValue !== undefined && (
          <img
            src={internalValue}
            alt="Signature Image"
            style={{ borderRadius: "15px", backgroundColor: "white" }}
          />
        )}
      </div>
      <div className="col-12" style={{ paddingTop: "1rem" }}>
        <button
          className="btn btn-danger"
          style={{ marginRight: "1rem" }}
          onClick={() => {
            var canvas = document.getElementById("sig-canvas");
            if (canvas) {
              canvas.width = canvas.width; // eslint-disable-line no-self-assign
            }

            handleOnChange(undefined);
          }}
        >
          {"Reset Signature"}
        </button>
        <button
          className="btn btn-success"
          disabled={internalValue !== undefined}
          onClick={() => {
            var canvas = document.getElementById("sig-canvas");

            const dataUrl = canvas.toDataURL();

            handleOnChange(dataUrl);
          }}
        >
          {"Submit Signature"}
        </button>
      </div>
    </div>
  );
}
